(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_7bd80be"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const grids = document.querySelectorAll('[class*="ai-product-feature__grid-"]');
    grids.forEach(grid => {
      if (grid.style.gridAutoFlow === 'column') {
        document.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') grid.scrollBy({ left: -400, behavior: 'smooth' });
          if (event.key === 'ArrowRight') grid.scrollBy({ left: 400, behavior: 'smooth' });
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
